// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__QdnF8","rotate":"loader_rotate__UV20v","loaderPath":"loader_loaderPath__FJLOn"};